export const MEDIA_EVENTS = ({
  LOADED_METADATA: 'loadedmetadata',
  LOADED_DATA: 'loadeddata',
  WAITING: 'waiting',
  PLAYING: 'playing',
  SEEKING: 'seeking',
  SEEKED: 'seeked',
  ENDED: 'ended',
  ERROR: 'error'
} as const);
export const MEDIA_ERROR_REASON = ({
  NETWORK_ERROR: 'NETWORK_ERROR',
  DECODE_ERROR: 'DECODE_ERROR',
  COMPATIBILITY_FAILURE: 'COMPATIBILITY_FAILURE',
  UNKNOWN: 'UNKNOWN'
} as const);
export const MEDIA_ERROR_CODE = {
  MEDIA_ERR_ABORTED: 1,
  MEDIA_ERR_NETWORK: 2,
  MEDIA_ERR_DECODE: 3,
  MEDIA_ERR_SRC_NOT_SUPPORTED: 4
};
export const MEDIA_METRIC_EVENTS = ({
  AUDIO_LOAD_TIME: 'audio_load_time',
  AUDIO_BUFFERING: 'audio_buffering',
  VIDEO_LOAD_TIME: 'video_load_time',
  VIDEO_BUFFERING: 'video_buffering',
  ERROR: 'media_error',
  LOAD_SUCCESS: 'media_load_success'
} as const);
export const MEDIA_INFO = {
  FILE_SIZE: 'file_size'
};
export const NETWORK_METRICS = {
  DOWNLINK: 'downlink'
};